// extracted by css-extract-rspack-plugin
module.exports =  {"SubNav":"koorh","selected":"GzyTm","noLRPadding":"BzDLJ"};